import parseCookies from 'lib/cookie/parser';
import dispatchEvent from '../analytics/dispatchEvent';
import addPageAction from '../analytics/addPageAction';

const MONETATE_COOKIE = 'mt.v';
const MONETATE_IMPRESSION = 'monetate:record:Impressions';
const NEW_RELIC_TEST =
  'DM | AB-1680 | navigation-experimental 50-50 A-A await monetate test';

const getExperienceByImpressionId = (id, monetateExperiences) => {
  const experiences = monetateExperiences || [];
  return experiences.find(
    experience => experience.experienceName.indexOf(id) > -1
  );
};

const postMonetateImpression = async (
  monetate,
  id,
  monetateExperiences = []
) => {
  const experience = getExperienceByImpressionId(id, monetateExperiences);
  if (experience) {
    const impressionRecord = {
      channel: monetate.channel,
      monetateId: parseCookies()[MONETATE_COOKIE] || null,
      events: [
        {
          eventType: MONETATE_IMPRESSION,
          impressionIds: [experience.impressionId],
        },
      ],
    };

    try {
      // Monetate postback
      await fetch(monetate.url, {
        method: 'POST',
        body: JSON.stringify(impressionRecord),
      });
      // Omniture postback
      dispatchEvent('dataStateChange', {
        action: 'managedImpression',
        campaigns: [
          {
            id: experience.impressionId,
            key: experience.experienceName,
            reports: [],
            split: experience.variantLabel,
          },
        ],
      });
      if (experience.experienceName === NEW_RELIC_TEST) {
        addPageAction(window, 'managedImpression', {
          id: experience.impressionId,
          split: experience.variantLabel,
          info: 'both fired',
        });
      }
    } catch (e) {
      if (experience.experienceName === NEW_RELIC_TEST) {
        addPageAction(window, 'managedImpression', {
          id: experience.impressionId,
          split: experience.variantLabel,
          info: 'monetate failed',
        });
      }

      console.error(e.message);
    }
  }
};

export default postMonetateImpression;
